// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___38XJR","container":"styles__container___3V75o","arrows":"styles__arrows___1mm4o"};